/**
 * verticalCardInfoContainer.tsx
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled vertical card info container.
 */
const VerticalCardInfoContainer = styled.div`
  position: relative;
  bottom: ${300 * Screen.widthRatio}px;
  padding: ${8 * Screen.widthRatio}px;
  height: ${284 * Screen.widthRatio}px;
  width: ${184 * Screen.widthRatio}px;
`;

export default withOpacity(VerticalCardInfoContainer);
